import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '../environments/environment';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export const b2cPolicies = {
  names: {
    signIn: environment.B2C_signInPolicy,
  },
  authorities: {
    signIn: {
      authority: `https://${environment.B2C_tenantName}.b2clogin.com/${environment.B2C_tenantName}.onmicrosoft.com/${environment.B2C_signInPolicy}`,
    },
  },
  authorityDomain: `${environment.B2C_tenantName}.b2clogin.com`,
};

export const b2cPolicies2 = {
  names: {
    signIn: environment.B2C_signInPolicy,
  },
  authorities: {
    signIn: {
      authority: `https://${environment.B2C_tenantName}.b2clogin.com/${environment.B2C_tenantName}.onmicrosoft.com/${environment.B2C_signInPolicy2}`,
    },
  },
  authorityDomain: `${environment.B2C_tenantName}.b2clogin.com`,
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.B2C_clientId,
    authority: b2cPolicies.authorities.signIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: environment.B2C_redirectUri,
  },

  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (logLevel, message, containsPii) => {
        if (logLevel === LogLevel.Error) {
          console.error(message);
        }
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: true,
    },
  },
};

export const protectedResourceScopes = [`https://${environment.B2C_tenantName}.onmicrosoft.com/b2c-api/b2c.read`];

export const loginRequest = {
  scopes: [] as string[],
};
